var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7832 2.12305C6.60512 2.36971 6.5 2.67253 6.5 3C6.5 3.82843 7.17157 4.5 8 4.5H10.5869C10.4006 5.02777 10.5173 5.63838 10.9395 6.06055C11.5252 6.64633 12.4748 6.64633 13.0605 6.06055L13.5059 5.61426C13.8232 6.34555 14 7.15203 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 5.10316 4.05285 2.68541 6.7832 2.12305ZM8 4.5C7.72386 4.5 7.5 4.72386 7.5 5V5.5H7C6.17157 5.5 5.5 6.17157 5.5 7C5.5 7.82843 6.17157 8.5 7 8.5H9C9.27614 8.5 9.5 8.72386 9.5 9C9.5 9.27614 9.27614 9.5 9 9.5H6C5.72386 9.5 5.5 9.72386 5.5 10C5.5 10.2761 5.72386 10.5 6 10.5H7.5V11C7.5 11.2761 7.72386 11.5 8 11.5C8.27614 11.5 8.5 11.2761 8.5 11V10.5H9C9.82843 10.5 10.5 9.82843 10.5 9C10.5 8.17157 9.82843 7.5 9 7.5H7C6.72386 7.5 6.5 7.27614 6.5 7C6.5 6.72386 6.72386 6.5 7 6.5H10C10.2761 6.5 10.5 6.27614 10.5 6C10.5 5.72386 10.2761 5.5 10 5.5H8.5V5C8.5 4.72386 8.27614 4.5 8 4.5Z",
    fill: "#002A69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 3L14 3M12 5L14 3L12 1",
    stroke: "#002A69",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney2);
export default __webpack_public_path__ + "static/media/Money2.3365bdfbe056e1072024acbc6128621b.svg";
export { ForwardRef as ReactComponent };